"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadElements = void 0;
var tslib_1 = require("tslib");
var loadElementsFromStaticElements_1 = require("./loadElementsFromStaticElements");
var loadElementsFromBackend_1 = require("./loadElementsFromBackend");
/**
 * @internal
 */
function loadElements(context, options, hiddenElementsInfo, staticElements) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, (staticElements === null || staticElements === void 0 ? void 0 : staticElements.length) ? loadElementsFromStaticElements_1.loadElementsFromStaticElements(options, hiddenElementsInfo, staticElements)
                    : loadElementsFromBackend_1.loadElementsFromBackend(context, options, hiddenElementsInfo)];
        });
    });
}
exports.loadElements = loadElements;
//# sourceMappingURL=loadElements.js.map